import React, { useEffect, useState } from 'react';
import { Button, Input, Space } from 'antd';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from 'utils/utils';
import { RefCode } from 'components/TableSearchBox';
import { addNewSearch } from 'utils/utils';
import 'components/TableSearchBox/index.scss';

const cx = classNames.bind('./index.scss');
export interface CrmSearchBoxProp {}

const CrmSearchBox = ({}: CrmSearchBoxProp): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();

  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchGubun, setSearchGubun] = useState<string|undefined>(undefined);

  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchInput('');
    setSearchGubun(undefined);
    navigate(location.pathname);
  };

  const onSearch = (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { search: value, pageNo: 1 }),
    });    
  };

  const onChangeGubun= (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { gubun: value, pageNo: 1 }),
    });      
  };  
  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const historySearch = getQueryString(location.search);
    if (historySearch.search) setSearchInput(historySearch.search);
    if (historySearch.gubun) setSearchGubun(historySearch.gubun);
  }, [location.search]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper')}>
      <Space>
        <RefCode codeValue={searchGubun} fieldName={'crm_type'} placeholder={'담당자구분'} onChangeSelect={onChangeGubun} />
        <Input.Search
          className={cx('searchInput')}
          value={searchInput}
          placeholder="기업명 혹은 이름을 입력하세요"
          onChange={onChange}
          onSearch={onSearch}
          allowClear
        />
        <Button onClick={onClickReset}>
          검색초기화
        </Button>                
      </Space>
    </div>
  );
};

export default CrmSearchBox;
